<template>
  <IconMaterial title="group_work" :size="size" />
</template>

<script>
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'IconSequence',

    components: {
      IconMaterial,
    },

    props: {
      size: {
        type: Number,
        default: 16,
      },
    },
  };
</script>
